import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { List } from 'immutable';
import VisualEditor from './RichtextControl/VisualEditor';
import { EditorProvider } from './RichtextControl/editorContext';
import RawEditor from './RichtextControl/RawEditor';
import { jsx as ___EmotionJSX } from "@emotion/react";
const MODE_STORAGE_KEY = 'cms.md-mode';
export default class RichtextControl extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    onAddAsset: PropTypes.func.isRequired,
    getAsset: PropTypes.func.isRequired,
    classNameWrapper: PropTypes.string.isRequired,
    editorControl: PropTypes.elementType.isRequired,
    value: PropTypes.string,
    field: ImmutablePropTypes.map.isRequired,
    getEditorComponents: PropTypes.func,
    t: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool
  };
  static defaultProps = {
    value: ''
  };
  constructor(props) {
    super(props);
    const preferredMode = localStorage.getItem(MODE_STORAGE_KEY) ?? 'rich_text';
    this.state = {
      mode:
      // When used inside a container/shortcode editor component, default to
      // rich text mode — the widget type already implies the editing surface.
      props.isEditorComponent ? 'rich_text' : this.getAllowedModes().indexOf(preferredMode) !== -1 ? preferredMode : this.getAllowedModes()[0],
      pendingFocus: false
    };
  }
  componentDidMount() {
    // Manually validate PropTypes - React 19 breaking change
    PropTypes.checkPropTypes(RichtextControl.propTypes, this.props, 'prop', 'RichtextControl');

    // Ensure containerised widgets start in the correct mode even if the
    // constructor ran before the prop was available (e.g. HMR / late prop).
    if (this.props.isEditorComponent && this.state.mode !== 'rich_text') {
      this.setState({
        mode: 'rich_text'
      });
    }
  }
  handleMode = mode => {
    this.setState({
      mode,
      pendingFocus: true
    });
    localStorage.setItem(MODE_STORAGE_KEY, mode);
  };
  setFocusReceived = () => {
    this.setState({
      pendingFocus: false
    });
  };
  getAllowedModes = () => this.props.field.get('modes', List(['rich_text', 'raw'])).toArray();
  focus() {
    this.setState({
      pendingFocus: true
    });
  }
  render() {
    const {
      classNameWrapper,
      field,
      t,
      isDisabled,
      getEditorComponents,
      editorControl,
      onChange,
      onAddAsset,
      getAsset,
      value
    } = this.props;
    const isEditorComponent = this.props.isEditorComponent;
    const isShowModeToggle = this.getAllowedModes().length > 1 && !isEditorComponent;
    const {
      mode,
      pendingFocus
    } = this.state;
    const visualEditor = ___EmotionJSX(EditorProvider, {
      editorControl: editorControl,
      editorComponents: getEditorComponents()
    }, ___EmotionJSX("div", {
      className: "cms-editor-visual"
    }, ___EmotionJSX(VisualEditor, {
      t: t,
      field: field,
      className: classNameWrapper,
      getEditorComponents: getEditorComponents,
      isDisabled: isDisabled,
      isEditorComponent: isEditorComponent,
      onMode: this.handleMode,
      isShowModeToggle: isShowModeToggle,
      onChange: onChange,
      onAddAsset: onAddAsset,
      getAsset: getAsset,
      pendingFocus: pendingFocus && this.setFocusReceived,
      value: value
    })));
    const rawEditor = ___EmotionJSX("div", {
      className: "cms-editor-raw"
    }, ___EmotionJSX(RawEditor, {
      onChange: onChange,
      onAddAsset: onAddAsset,
      getAsset: getAsset,
      isShowModeToggle: isShowModeToggle,
      onMode: this.handleMode,
      className: classNameWrapper,
      value: value,
      field: field,
      pendingFocus: pendingFocus && this.setFocusReceived,
      t: t
    }));
    return mode === 'rich_text' ? visualEditor : rawEditor;
  }
}